export default __webpack_public_path__ + "static/media/indice.573a0023.svg";